import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, TablePagination, Button, Chip } from '@mui/material';
import { People } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useAnalysis } from '../AnalysisContext';
import { PageHeader, EmptyState, NameAvatar, formatDate } from '../components/ui';
import { Box } from '@mui/material';

export default function Shared() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { sharedWithMe, loadingLists, loadShared } = useAnalysis();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rows = [...sharedWithMe].sort((a, b) => new Date(b.sharedAt || 0) - new Date(a.sharedAt || 0));
  const pageRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const open = (s) => { if (loadShared(s)) navigate('/'); };

  return (
    <>
      <PageHeader title={t('nav.shared', 'Shared with me')} subtitle={t('shared.subtitle', 'Analyses that other people shared with you.')} />
      {!loadingLists && sharedWithMe.length === 0 ? (
        <EmptyState icon={<People />} title={t('shared.emptyTitle', 'Nothing shared with you yet')} text={t('shared.emptyText', 'When a colleague shares an analysis with your email address it will show up here.')} />
      ) : (
        <Paper variant="outlined">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('history.customer', 'Customer / workload')}</TableCell>
                  <TableCell>{t('shared.from', 'Shared by')}</TableCell>
                  <TableCell align="center">{t('history.servers', 'Servers')}</TableCell>
                  <TableCell>{t('shared.on', 'Shared on')}</TableCell>
                  <TableCell align="right" />
                </TableRow>
              </TableHead>
              <TableBody>
                {pageRows.map((s, i) => (
                  <TableRow key={i} hover sx={{ cursor: 'pointer' }} onClick={() => open(s)} style={{ animation: 'fadeIn .5s ease both', animationDelay: `${Math.min(i, 12) * 45}ms` }}>
                    <TableCell sx={{ fontWeight: 600 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}><NameAvatar name={s.analysis?.customerName} />{s.analysis?.customerName || 'Analysis'}</Box></TableCell>
                    <TableCell><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><NameAvatar name={s.sharerEmail} size={24} />{s.sharerEmail || 'unknown'}</Box></TableCell>
                    <TableCell align="center"><Chip size="small" variant="outlined" label={s.analysis?.serverCount || 1} /></TableCell>
                    <TableCell>{formatDate(s.sharedAt)}</TableCell>
                    <TableCell align="right"><Button size="small" onClick={e => { e.stopPropagation(); open(s); }}>{t('history.open', 'Open')}</Button></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination component="div" count={rows.length} page={page} onPageChange={(e, p) => setPage(p)} rowsPerPage={rowsPerPage}
            onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }} rowsPerPageOptions={[10, 25]} />
        </Paper>
      )}
    </>
  );
}
